'use client';

import { type PlateElementProps, PlateElement } from '@udecode/plate/react';

export function CodeLineElement(props: PlateElementProps) {
  return <PlateElement {...props} />;
}
